import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                 primary: '#d54252',
                secondary: '#2b6aa4',
            }
        }
        
    }
});
